export default "<p>view-coupon-management works!</p>\r\n";